import template from './InstallPluginModalView.html';
import controller from './InstallPluginModalController';
export default (params) => {
    return {
        template,
        controller,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            confirm: params.confirm,
        },
    };
};
